import { styled } from '@mui/material/styles';

import Box from '~/common/components/Box';
import theme from '~/theme/';

const StyledFocusedWrapper = styled<any>(Box)`
  background-color: ${({ isFocused }) =>
    isFocused ? theme.colors?.gray[200] : 'transparent'};
  border-radius: 0.25rem;
  transition: background-color 0.05s ease-in-out;
  padding: 0;
`;

type FocusedWrapperProps = {
  isFocused?: boolean;
  as?: string;
  children?: React.ReactNode;
};

export default function FocusedWrapper({
  isFocused,
  as = 'div',
  children,
}: Readonly<FocusedWrapperProps>) {
  return (
    <StyledFocusedWrapper isFocused={isFocused} as={as}>
      {children}
    </StyledFocusedWrapper>
  );
}
